import styled from '@emotion/styled';
import { withConfig } from 'src/utils/withConfig';
import { setMainLogoWrapper } from 'src/components/Header/Logotype.style';
import { EnergyLogo } from 'src/assets/logos/EnergyLogo';
import { EnergyBrandIcon } from 'src/assets/brandIcons/EnergyBrandIcon';

export const EnergyMainLogoWrapper = withConfig(theme => styled('div', { label: 'EnergyMainLogoWrapper' })`
    ${setMainLogoWrapper(theme)};
`);

export const EnergyMainLogo = styled(EnergyLogo, { label: 'EnergyMainLogo' })`
    width: 48px;
    height: 24px;
    margin: 0 auto;
`;

export const EnergyBrandIconWrapper = styled(EnergyBrandIcon, { label: 'EnergyBrandIconWrapper' })`
    cursor: pointer;
    flex: 0 0 32px;
    margin: 0 auto;
    width: 32px;
`;
